import { t } from 'i18next';

import { setAttachmentContentType } from '../../actions/screen';
import { showModal, TYPES } from '../../actions/modal';
import { getActualData, preloadSignatureUrl } from '../../actions/tasks';
import { openFlightChat, openMessengerInbox } from '../../actions/messenger';
import { ButtonType, redirectPages, sidebarButton } from './constants';

export const sidebarItemClick = (
    value,
    currentLeg,
    currentTask,
    currentFlightId,
    dispatch,
    handleRedirectPage,
    handleSetValue,
    showNoticePreview
) => {
    if (value !== ButtonType.NOTAMS && value !== ButtonType.CHECK_LIST) {
        handleSetValue(value);
    }

    if (value === ButtonType.TASKS) {
        handleRedirectPage('flight-task');
    } else if (value === ButtonType.SHOW_TASK) {
        dispatch(preloadSignatureUrl(currentTask));
        dispatch(
            showModal(TYPES.FLIGHT_TASK, {
                title: t('modal.taskTitle'),
                id: currentTask,
            })
        );
    } else if (value === ButtonType.FLIGHT) {
        handleRedirectPage('flight');
    } else if (value === ButtonType.FLIGHT_INFO) {
        handleRedirectPage('flight-info');
    } else if (value === ButtonType.CREW) {
        handleRedirectPage('crew');
    } else if (value === ButtonType.PASSENGERS) {
        handleRedirectPage('passengers');
    } else if (value === ButtonType.TELEGRAMS || value === ButtonType.LIMITATIONS || value === ButtonType.DOCUMENTS) {
        const contentType = sidebarButton[value]?.attachmentContentType;

        dispatch(setAttachmentContentType(contentType));
        handleRedirectPage('attachments');
    } else if (value === ButtonType.NOTAMS) {
        dispatch(
            showModal(TYPES.NOTICE, {
                title: 'NOTAM',
                showPreview: showNoticePreview,
            })
        );
    } else if (value === ButtonType.CHECK_LIST) {
        dispatch(
            showModal(TYPES.CHECK_LIST, {
                title: t('modal.checkList'),
            })
        );
    } else if (value === ButtonType.AIRPORT_SERVICE) {
        handleRedirectPage('airport-service');
    } else if (value === ButtonType.ADD_REPORT) {
        dispatch(
            showModal(TYPES.REPORT, {
                title: t('modal.addReport'),
                report: { planFlightId: currentLeg },
            })
        );
    } else if (value === ButtonType.REPORTS) {
        handleRedirectPage('reports');
    } else if (value === ButtonType.LIBRARY) {
        handleRedirectPage('library');
    } else if (value === ButtonType.MESSAGES) {
        if (currentFlightId) {
            dispatch(openFlightChat(currentFlightId));
        } else {
            dispatch(openMessengerInbox());
        }
    } else if (value === ButtonType.SUMMARY_TASK) {
        handleRedirectPage('summary-task');
    } else if (value === ButtonType.GET_DATA) {
        dispatch(getActualData());
    } else if (value === ButtonType.SEND_DATA) {
        dispatch(showModal(TYPES.SEND_DATA, { title: t('sendData') }));
    }
};

export const getButtonType = (page, currentContentType) =>
    page === 'attachments'
        ? +Object.keys(sidebarButton).find((key) => sidebarButton[key]?.attachmentContentType === currentContentType)
        : redirectPages[page];
